import { c as _c } from "react/compiler-runtime";
import { AffiliateDashboardTagButton } from 'modules/affiliate-dashboard/components/affiliate-dashboard-tag-button';
import { AffiliateDashboardVendorAvatarButton } from 'modules/affiliate-dashboard/components/affiliate-dashboard-vendor-avatar-button';
import { useAffiliateDashboardEmptyState } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-empty-state';
import { useAffiliateDashboardPayments } from 'modules/affiliate-dashboard/hooks/use-affiliate-dashboard-payments';
import { AffiliateDashboardFilterInterface, AffiliateDashboardFilterWithTagInterface, TagId } from 'modules/affiliate-dashboard/types/affiliate-dashboard-interface';
import { AffiliateDashboardPaymentsInterface } from 'modules/affiliate-dashboard/types/affiliate-dashboard-payments-interface';
import { AffiliateCommissionCell } from 'modules/affiliate/components/affiliate-commission-cell';
import { AffiliateMobileCard } from 'modules/affiliate/components/affiliate-mobile-card';
import React, { useEffect, useState, type ReactNode } from 'react';
import { FormSelect } from 'shared/components';
import ListingLayout from 'shared/components/listing-layout';
import { CompactTime, RelativeTime } from 'shared/components/relative-time';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { PricePlanTooltip } from 'shared/components/tooltip/price-plan-tooltip';
import { useDidUpdateEffect } from 'shared/hooks/use-did-update-effect';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { SelectorDataInterface } from 'shared/types/selector-data-interface';
interface AffiliateDashboardPaymentsProps {
  mainFilter: AffiliateDashboardFilterInterface;
  tagsData: SelectorDataInterface<TagId>[] | undefined;
  setMainFilter: React.Dispatch<React.SetStateAction<AffiliateDashboardFilterInterface>>;
}
const AffiliateDashboardPayments = t0 => {
  const $ = _c(89);
  const {
    mainFilter,
    tagsData,
    setMainFilter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    limit,
    setLimit,
    pagination,
    setPagination,
    setFirstPage
  } = usePagination(true);
  let t1;
  if ($[0] !== mainFilter) {
    t1 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[0] = mainFilter;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [filterWithTag, setFilterWithTag] = useState(t1);
  let t2;
  let t3;
  if ($[2] !== mainFilter) {
    t2 = () => {
      setFilterWithTag(prev => ({
        ...prev,
        ...mainFilter
      }));
    };
    t3 = [mainFilter];
    $[2] = mainFilter;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== filterWithTag || $[6] !== limit || $[7] !== pagination) {
    t4 = {
      filter: filterWithTag,
      pagination,
      limit
    };
    $[5] = filterWithTag;
    $[6] = limit;
    $[7] = pagination;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    affiliatePayments,
    counter
  } = useAffiliateDashboardPayments(t4);
  const t5 = !!filterWithTag.vendorId || !!filterWithTag.affiliateTag;
  let t6;
  if ($[9] !== affiliatePayments || $[10] !== t5) {
    t6 = {
      data: affiliatePayments,
      isFiltered: t5
    };
    $[9] = affiliatePayments;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    tableData,
    emptyStateProps
  } = useAffiliateDashboardEmptyState("payments", t6);
  let t7;
  if ($[12] !== setFirstPage) {
    t7 = tagId => {
      setFilterWithTag(prev_0 => ({
        ...prev_0,
        affiliateTag: tagId
      }));
      setFirstPage();
    };
    $[12] = setFirstPage;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const changeTag = t7;
  let t8;
  if ($[14] !== setFirstPage) {
    t8 = () => {
      setFirstPage();
    };
    $[14] = setFirstPage;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== mainFilter || $[17] !== setFirstPage) {
    t9 = [mainFilter, setFirstPage];
    $[16] = mainFilter;
    $[17] = setFirstPage;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  useDidUpdateEffect(t8, t9);
  let t10;
  if ($[19] !== setMainFilter) {
    t10 = payment => <AffiliateDashboardVendorAvatarButton vendor={payment.payment.user} onClick={() => setMainFilter(prev_1 => ({
      ...prev_1,
      vendorId: payment.payment.user.id
    }))} />;
    $[19] = setMainFilter;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const renderAvatar = t10;
  const renderDetails = _temp;
  let t11;
  if ($[21] !== renderAvatar) {
    t11 = (payment_1, footer_0) => <div className="flex min-w-0 items-center gap-3">{renderAvatar(payment_1)}{renderDetails(payment_1, footer_0)}</div>;
    $[21] = renderAvatar;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const renderVendor = t11;
  let t12;
  if ($[23] !== changeTag) {
    t12 = payment_2 => <div className="min-w-0"><AffiliateDashboardTagButton tag={payment_2.payment.customer.affiliateTag} onClick={changeTag} /></div>;
    $[23] = changeTag;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const renderTag = t12;
  let t13;
  if ($[25] !== t) {
    t13 = t("dashboard.affiliate_dashboard.vendor_product");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== renderVendor) {
    t14 = payment_3 => renderVendor(payment_3);
    $[27] = renderVendor;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = {
      key: "vendorProduct",
      widthPercent: 45,
      header: t13,
      onRender: t14
    };
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t) {
    t16 = t("dashboard.affiliate_dashboard.tags");
    $[32] = t;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== renderTag || $[35] !== t16) {
    t17 = {
      key: "tags",
      header: t16,
      widthPercent: 15,
      onRender: renderTag
    };
    $[34] = renderTag;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t) {
    t18 = t("dashboard.affiliate.commission");
    $[37] = t;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18) {
    t19 = {
      key: "commission",
      widthPercent: 25,
      header: t18,
      onRender: _temp2
    };
    $[39] = t18;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t) {
    t20 = t("global.date");
    $[41] = t;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== t20) {
    t21 = {
      key: "date",
      widthPercent: 15,
      header: t20,
      onRender: _temp3
    };
    $[43] = t20;
    $[44] = t21;
  } else {
    t21 = $[44];
  }
  let t22;
  if ($[45] !== t15 || $[46] !== t17 || $[47] !== t19 || $[48] !== t21) {
    t22 = [t15, t17, t19, t21];
    $[45] = t15;
    $[46] = t17;
    $[47] = t19;
    $[48] = t21;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  const columns = t22;
  let t23;
  if ($[50] !== t) {
    t23 = t("dashboard.affiliate.payments");
    $[50] = t;
    $[51] = t23;
  } else {
    t23 = $[51];
  }
  let t24;
  if ($[52] !== mainFilter) {
    t24 = {
      ...mainFilter,
      affiliateTag: undefined
    };
    $[52] = mainFilter;
    $[53] = t24;
  } else {
    t24 = $[53];
  }
  let t25;
  if ($[54] !== filterWithTag || $[55] !== t24) {
    t25 = {
      filter: filterWithTag,
      setFilter: setFilterWithTag,
      defaultFilters: t24
    };
    $[54] = filterWithTag;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t || $[58] !== tagsData) {
    t26 = [{
      field: "affiliateTag",
      onRender: (value, onChange) => <FormSelect placeholder={t("dashboard.affiliate_dashboard.any_tag")} value={value} data={tagsData} onChange={onChange} />
    }];
    $[57] = t;
    $[58] = tagsData;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== setPagination || $[61] !== t25 || $[62] !== t26) {
    t27 = {
      filterer: t25,
      setPagination,
      filterable: t26
    };
    $[60] = setPagination;
    $[61] = t25;
    $[62] = t26;
    $[63] = t27;
  } else {
    t27 = $[63];
  }
  let t28;
  if ($[64] !== renderAvatar || $[65] !== renderTag) {
    t28 = payment_6 => <AffiliateMobileCard avatar={renderAvatar(payment_6)} aside={<AffiliateCommissionCell payment={payment_6} />} footer={payment_6.payment.customer.affiliateTag && renderTag(payment_6)}>{renderDetails(payment_6)}<div className="mt-1"><RelativeTime time={payment_6.payment.paidAt} /></div></AffiliateMobileCard>;
    $[64] = renderAvatar;
    $[65] = renderTag;
    $[66] = t28;
  } else {
    t28 = $[66];
  }
  let t29;
  if ($[67] !== renderTag || $[68] !== renderVendor) {
    t29 = payment_7 => <div className="flex items-center gap-5"><div className="min-w-0 flex-3">{renderVendor(payment_7, <CompactTime time={payment_7.payment.paidAt} />)}</div><div className="flex min-w-0 flex-2 items-center gap-5"><div className="min-w-0 flex-1">{renderTag(payment_7)}</div><div className="shrink-0"><AffiliateCommissionCell payment={payment_7} /></div></div></div>;
    $[67] = renderTag;
    $[68] = renderVendor;
    $[69] = t29;
  } else {
    t29 = $[69];
  }
  let t30;
  if ($[70] !== limit || $[71] !== setLimit) {
    t30 = {
      limit,
      setLimit
    };
    $[70] = limit;
    $[71] = setLimit;
    $[72] = t30;
  } else {
    t30 = $[72];
  }
  let t31;
  if ($[73] !== pagination || $[74] !== setPagination) {
    t31 = {
      pagination,
      setPagination
    };
    $[73] = pagination;
    $[74] = setPagination;
    $[75] = t31;
  } else {
    t31 = $[75];
  }
  let t32;
  if ($[76] !== columns || $[77] !== emptyStateProps || $[78] !== t28 || $[79] !== t29 || $[80] !== t30 || $[81] !== t31 || $[82] !== tableData) {
    t32 = <Table data={tableData} renderMobileRow={t28} renderTabletRow={t29} columns={columns} limiter={t30} paginator={t31} emptyStateProps={emptyStateProps} />;
    $[76] = columns;
    $[77] = emptyStateProps;
    $[78] = t28;
    $[79] = t29;
    $[80] = t30;
    $[81] = t31;
    $[82] = tableData;
    $[83] = t32;
  } else {
    t32 = $[83];
  }
  let t33;
  if ($[84] !== counter || $[85] !== t23 || $[86] !== t27 || $[87] !== t32) {
    t33 = <ListingLayout title={t23} counter={counter} filterData={t27}>{t32}</ListingLayout>;
    $[84] = counter;
    $[85] = t23;
    $[86] = t27;
    $[87] = t32;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  return t33;
};
export default AffiliateDashboardPayments;
function _temp(payment_0, footer) {
  return <div className="flex min-w-0 flex-col">{payment_0.payment.user.affiliateProgramBrandName && <span className="text-text-tertiary truncate">{payment_0.payment.user.affiliateProgramBrandName}</span>}{payment_0.orderItem.pricePlan && <PricePlanTooltip pricePlan={payment_0.orderItem.pricePlan} hiddenInfo={true}><span className="text-text-primary block truncate">{payment_0.orderItem.pricePlan.name}</span></PricePlanTooltip>}<span className="text-text-tertiary truncate text-sm">{payment_0.payment.customer.email}</span>{footer}</div>;
}
function _temp2(payment_4) {
  return <AffiliateCommissionCell payment={payment_4} />;
}
function _temp3(payment_5) {
  return <RelativeTime time={payment_5.payment.paidAt} />;
}